import {
  BoardSetWidth,
  Wrapper,
} from 'src/styles/user-mobile/OverviewStyleMobile';
import { useEffect, useState } from 'react';
// import { TICKETING_ID } from 'src/assets/database/ticketData';
import TicketCancelTitleArea from './molcules-cancel/TicketCancelTitleArea';
import ReservationInfo from './molcules-cancel/ReservationInfo';
import ServerTesting from './modal/ServerTesting';
import TicketCancelInputField from './molcules-cancel/TicketCancelInputField';
import CodeSentModal from './modal/CodeSentModal';
import CodeSendFailedModal from './modal/CodeSendFailedModal';
import TelConfirmedCancel from './modal/TelConfirmedCancel';
import NotConfirmed from './modal/NotConfirmed';
import CancelNoTime from './modal/CancelNoTime';

export default function CancelTemplates() {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isVerified, setIsVerified] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [currentModal, setCurrentModal] = useState<string | null>(null);
  const [startFetch, setStartFetch] = useState(false);
  const festivalId = 8;

  const openModal = (modalName: string) => {
    setCurrentModal(modalName);
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
    setCurrentModal(null);
  };

  const renderModal = () => {
    if (!modalOpen) return null;
    switch (currentModal) {
      case 'ServerTesting':
        return <ServerTesting onClose={closeModal} />;
      case 'CodeSent':
        return <CodeSentModal onClose={closeModal} />;
      case 'CodeSendFailed':
        return <CodeSendFailedModal onClose={closeModal} />;
      case 'TelConfirmed':
        return <TelConfirmedCancel onClose={closeModal} />;
      case 'NotConfirmed':
        return <NotConfirmed onClose={closeModal} />;
      case 'CancelNoTime':
        return <CancelNoTime onClose={closeModal} />;
      default:
        return null;
    }
  };
  // useEffect(() => {
  //   // openModal('ServerTesting');
  // }, []);

  useEffect(() => {
    const currentTime = new Date();
    const cancelStart = new Date('2025-05-24T10:00:00+09:00');
    const cancelEnd = new Date(cancelStart.getTime() + 6 * 24 * 60 * 60 * 1000);

    if (currentTime < cancelStart || currentTime > cancelEnd) {
      openModal('CancelNoTime');
    }
  }, []);

  return (
    <Wrapper>
      <BoardSetWidth>
        <TicketCancelTitleArea />
        <TicketCancelInputField
          phoneNumber={phoneNumber}
          setPhoneNumber={setPhoneNumber}
          isVerified={isVerified}
          setIsVerified={setIsVerified}
          openModal={openModal}
          setStartFetch={setStartFetch}
        />
        {startFetch && <ReservationInfo festivalId={festivalId} />}
        {renderModal()}
      </BoardSetWidth>
    </Wrapper>
  );
}
